module.exports = __webpack_public_path__ + "static/media/10.6d602984.jpg";